import { getFleetMediaUrl } from "../../../../../api/fleet-management/api";


export const initialVehicleForm = {
  make: "",
  model: "",
  year: "",
  registrationNumber: "",
  engineNumber: "",
  chassisNumber: "",
  category: "",
  fuelType: "",
  fuelTankCapacity: "",
  images: [],
  specifications: {
    transmission: "",
    seatingCapacity: "",
    hasDriver: false,
    airConditioned: true,
  },
  features: [],
  price: "",
  status: "available",
};

export const normalizeVehicles = (data) => {
  if (Array.isArray(data)) return data;
  return data?.vehicles || data?.items || [];
};

export const filterVehicles = (vehicles, searchTerm) => {
  const term = searchTerm.trim().toLowerCase();
  if (!term) return vehicles;

  return vehicles.filter((vehicle) => {
    const make = vehicle?.make?.toLowerCase() || "";
    const model = vehicle?.model?.toLowerCase() || "";
    const registration = vehicle?.registrationNumber?.toLowerCase() || "";
    const category = vehicle?.category?.toLowerCase() || "";
    const status = vehicle?.status?.toLowerCase() || "";

    return (
      make.includes(term) ||
      model.includes(term) ||
      registration.includes(term) ||
      category.includes(term) ||
      status.includes(term)
    );
  });
};

export const getVehicleStatusBadgeClass = (status) => {
  if (status === "available") return "badge bg-success";
  if (status === "booked") return "badge bg-primary";
  if (status === "maintenance") return "badge bg-warning text-dark";
  return "badge bg-secondary";
};


export const mapVehicleToForm = (vehicle) => ({
  make: vehicle?.make || "",
  model: vehicle?.model || "",
  year: vehicle?.year ? String(vehicle.year) : "",
  registrationNumber: vehicle?.registrationNumber || "",
  engineNumber: vehicle?.engineNumber || "",
  chassisNumber: vehicle?.chassisNumber || "",
  category: vehicle?.category || "",
  fuelType: vehicle?.fuelType || "",
  fuelTankCapacity: vehicle?.fuelTankCapacity ? String(vehicle.fuelTankCapacity) : "",
  images: Array.isArray(vehicle?.images)
    ? vehicle.images.map((image) => ({
        // Convert relative URL to full URL for display in form
        url: image?.url ? getFleetMediaUrl(image.url) : "",
        type: image?.type || "exterior",
      }))
    : [],
  specifications: {
    transmission: vehicle?.specifications?.transmission || "",
    seatingCapacity: vehicle?.specifications?.seatingCapacity
      ? String(vehicle.specifications.seatingCapacity)
      : "",
    hasDriver: Boolean(vehicle?.specifications?.hasDriver),
    airConditioned:
      vehicle?.specifications?.airConditioned === undefined
        ? true
        : Boolean(vehicle.specifications.airConditioned),
  },
  features: Array.isArray(vehicle?.features)
    ? vehicle.features.map((feature) => String(feature || ""))
    : [],
  price: vehicle?.price ? String(vehicle.price) : "",
  status: vehicle?.status || "available",
});

export const validateVehicleForm = (form) => {
  const errors = {};

  if (!form.registrationNumber.trim()) {
    errors.registrationNumber = "Registration number is required.";
  }

  if (!form.category.trim()) {
    errors.category = "Category is required.";
  }

  if (!form.price || Number(form.price) <= 0) {
    errors.price = "Price must be greater than 0.";
  }

  if (form.year && Number(form.year) < 1900) {
    errors.year = "Year must be a valid value.";
  }

  if (form.fuelTankCapacity && Number(form.fuelTankCapacity) < 0) {
    errors.fuelTankCapacity = "Fuel tank capacity cannot be negative.";
  }

  if (form.specifications.seatingCapacity && Number(form.specifications.seatingCapacity) <= 0) {
    errors["specifications.seatingCapacity"] = "Seating capacity must be greater than 0.";
  }

  form.images.forEach((image, index) => {
    if (image.url && !image.type) {
      errors[`images.${index}.type`] = "Image type is required when URL is provided.";
    }
  });

  return errors;
};

export const buildVehiclePayload = (form) => {
  const images = form.images
    .filter((image) => image.url.trim())
    .map((image) => ({
      url: image.url.trim(),
      type: image.type || "exterior",
    }));

  const features = form.features
    .map((feature) => feature.trim())
    .filter(Boolean);

  return {
    make: form.make.trim(),
    model: form.model.trim(),
    year: form.year ? Number(form.year) : undefined,
    registrationNumber: form.registrationNumber.trim(),
    engineNumber: form.engineNumber.trim(),
    chassisNumber: form.chassisNumber.trim(),
    category: form.category.trim(),
    fuelType: form.fuelType || undefined,
    fuelTankCapacity: form.fuelTankCapacity ? Number(form.fuelTankCapacity) : undefined,
    images,
    specifications: {
      transmission: form.specifications.transmission || undefined,
      seatingCapacity: form.specifications.seatingCapacity
        ? Number(form.specifications.seatingCapacity)
        : undefined,
      hasDriver: Boolean(form.specifications.hasDriver),
      airConditioned: Boolean(form.specifications.airConditioned),
    },
    features,
    price: Number(form.price),
    status: form.status,
  };
};
